"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _diamondList = _interopRequireDefault(require("./diamondList.vue"));
var _diamondDetail = _interopRequireDefault(require("./diamondDetail.vue"));
var _diamond = require("@/api/basic/diamond");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'diamond',
  components: {
    diamondDetail: _diamondDetail.default,
    diamondList: _diamondList.default
  },
  data: function data() {
    return {
      loading: false,
      taskAddKey: 0,
      // 每次更改它都会强制刷新 TaskAdd
      ruleOptions: [],
      activeTab: 'diamondList',
      tabs: ['diamondList', 'diamondDetail'],
      searchForm: {
        orderId: '',
        shopId: '',
        memberLv: '',
        isAuth: '',
        type: '',
        page: 1,
        limit: 10,
        total: 0,
        times: ''
      },
      tableData: [],
      activeStep: 1
    };
  },
  computed: {
    // maxHeight() {
    //     return `${window.innerHeight - 497}px`;
    // },
  },
  methods: {
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    viewDetail: function viewDetail(row) {
      var _this = this;
      console.log("row", row);
      (0, _diamond.getDetail)(row.id).then(function (res) {
        console.log("res", res);
        res.forEach(function (item) {
          var date = new Date(item.createTime);
          var year = date.getFullYear();
          var month = _this.pad(date.getMonth() + 1);
          var day = _this.pad(date.getDate());
          var hours = _this.pad(date.getHours());
          var mins = _this.pad(date.getMinutes());
          var secs = _this.pad(date.getSeconds());
          item.createTime = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
        });
        _this.activeStep = res.length;
        _this.detail = row;
        _this.detail.reviewList = res;
        console.log("this.detail", _this.detail);
      });
      this.activeTab = 'diamondDetail';
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    }
  },
  mounted: function mounted() {}
};